import { Deserializable } from '../protocols/deserializable';
import { RemittancePaymentStatus } from './remittance-payment-status';
import { RemittanceStatus } from './remittance-status';

export class OpenRemittance implements Deserializable {
  public id!: number;
  public statusId!: number;
  public status!: RemittanceStatus;
  public paymentStatusId!: number;
  public paymentStatus!: RemittancePaymentStatus;

  public onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;
    if (!!this.status) {
      this.status = Deserialize?.instanceOf(RemittanceStatus, this.status);
    }
    if (!!this.paymentStatus) {
      this.paymentStatus = Deserialize?.instanceOf(RemittancePaymentStatus, this.paymentStatus);
    }
  }
}

export class MemberOpenRemittancesByEmployer implements Deserializable {
  public employerId!: number;
  public openRemittances: OpenRemittance[] = [];

  public onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;
    this.openRemittances = Deserialize?.arrayOf(OpenRemittance, this.openRemittances);
  }
}
